module.exports = __webpack_public_path__ + "media/error.f8d95f31.wav";